export const notifications = {
    toast: {
        success: {
            summary: "Success",
            passwordResetSent: "Password reset email sent",
            profileSaved: "Profile saved successfully",
            deviceDeleted: "Device has been deleted",
            deviceAdded: "Device has been added",
            deviceSaved: "Device has been saved",
            fileDeleted: "File has been deleted",
            checksImported: "Checks imported successfully",
        },
        error: {
            summary: "Error",
            invalidCredentials: "Invalid user credentials",
            unexpectedError: "Unexpected error occurred",
            noChecksToImport: "No checks to import",
            invalidFileFormat: "Invalid file format",
        }
    }
}
